import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import sessionReducer from './session';
import subscriptionReducer from './subscription';
import pixReducer from './pix';
import brandReducer from './brand';
import uiReducer from './ui';

export default history =>
  combineReducers({
    router: connectRouter(history),
    sessionState: sessionReducer,
    subscriptionState: subscriptionReducer,
    brandState: brandReducer,
    uiState: uiReducer,
    pixState: pixReducer,
  });
